import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormulaireService } from '../saisie/formulaire.service';
import { mapFiltre } from './questionnaire.metadata';

@Injectable({
  providedIn: 'root'
})
export class FiltreService {
  public mapFiltre: Map<string, { condition: any, varFils: string[] }[]>;
  constructor(private formulaireService: FormulaireService) {
    this.initialisationMapFiltre();
   }


  private initialisationMapFiltre(): void {
    this.mapFiltre = mapFiltre;
  }

  // Declaration de filtres generaux onglets
  // Savoir si on doit afficher les onglets F et G sur les BAV
  public isNotBav(): boolean {
    return this.formulaireService.getRootForm().get('dg').get('xxBavNb').value === 0;
  }
  

  // Pour rafraichir les variables possedant des controles croisés entre onglet !!
  // fonction(s) appelée(s) dans le ts de l'onglet fille
  // Basé sur une variable sur chaque onglet
  public refreshErreur(subTab: Subscription[], onglet1: any, champ1: any, onglet2: any, champ2: any): any {
    console.log('refresh');
    subTab.push(this.formulaireService.getRootForm().get(onglet1).get(champ1).valueChanges.pipe(debounceTime(100)).subscribe(valeur => {
      if (this.formulaireService.getRootForm().get(onglet2).get(champ2).enabled) {
        this.formulaireService.getRootForm().get(onglet2).get(champ2).enable();
      }
     }));
    this.formulaireService.getRootForm().get(onglet1).get(champ1).updateValueAndValidity();
  }

  // Base sur plusieurs variables sur un des onglets
  public refreshErreur2(subTab: Subscription[], onglet1: any, champ1: any, onglet2: any, champ2: any, champ3: any): any {
    subTab.push(this.formulaireService.getRootForm().get(onglet1).get(champ1).valueChanges.pipe(debounceTime(100)).subscribe(valeur => {
      if (this.formulaireService.getRootForm().get(onglet2).get(champ2).enabled) {
        this.formulaireService.getRootForm().get(onglet2).get(champ2).enable();
      }
      if (this.formulaireService.getRootForm().get(onglet2).get(champ3).enabled) {
        this.formulaireService.getRootForm().get(onglet2).get(champ3).enable();
      }
     }));
    this.formulaireService.getRootForm().get(onglet1).get(champ1).updateValueAndValidity();
  }

}

